import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../img/imagewithbasebath";
import { setToogleHeader } from "../redux/action";
import PropTypes from "prop-types";

const TableTop = ({ onRefresh, onPrint, onPdf, onExcel, onEdit, hideCollapse = false }) => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );

    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );

    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>
            Printer
        </Tooltip>
    );

    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );

    return (
        <ul className="table-top-head">
            {
                onEdit &&
                <li>
                    <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Pdf"
                        onClick={onEdit}
                    >
                        <i
                            data-feather="edit"
                            className="feather-edit sales-action"
                        />
                    </Link>
                </li>
            }
            {
                onPdf &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                        <Link onClick={onPdf}>
                            <ImageWithBasePath
                                src="assets/img/icons/pdf.svg"
                                alt="img"
                            />
                        </Link>
                    </OverlayTrigger>
                </li>
            }
            {
                onExcel &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                        <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={onExcel}>
                            <ImageWithBasePath
                                src="assets/img/icons/excel.svg"
                                alt="img"
                            />
                        </Link>
                    </OverlayTrigger>
                </li>
            }
            {
                onPrint &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                        <Link data-bs-toggle="tooltip" data-bs-placement="top">
                            <i data-feather="printer" className="feather-printer" />
                        </Link>
                    </OverlayTrigger>
                </li>
            }
            {
                onRefresh &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                        <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={onRefresh}>
                            <RotateCcw />
                        </Link>
                    </OverlayTrigger>
                </li>
            }
            {
                !hideCollapse &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                        <Link
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            id="collapse-header"
                            className={data ? "active" : ""}
                            onClick={() => {
                                dispatch(setToogleHeader(!data));
                            }}
                        >
                            <ChevronUp />
                        </Link>
                    </OverlayTrigger>
                </li>
            }
        </ul>
    )
}

TableTop.propTypes = {
    onRefresh: PropTypes.func,
    onPrint: PropTypes.func,
    onPdf: PropTypes.func,
    onExcel: PropTypes.func,
    onEdit: PropTypes.func,
    hideCollapse: PropTypes.bool
};

export default TableTop